import { Layout, Menu } from "antd";
import styled from "styled-components";
import logo from "../../assets/images/logo.png";
import logoMini from "../../assets/images/logo-mini.png";
import {
  AiOutlineDashboard,
  AiOutlineProduct,
  AiOutlineSetting,
} from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useMemo } from "react";
import { MdOutlineCategory, MdPeopleOutline } from "react-icons/md";
import { TbUsersGroup } from "react-icons/tb";
import { RiBillLine } from "react-icons/ri";
import { PiFlagBannerFoldLight } from "react-icons/pi";
import { BiPurchaseTag } from "react-icons/bi";
import { useAppContext } from "../../contexts/appContext";

const { Sider } = Layout;

export const Sidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAppContext();

  const userPermissions = user?.access;
  // Memoize the route mapping object
  const routes = useMemo(
    () => ({
      dashboard: "/dashboard",
      product: "/product",
      category: "/category",
      staff: "/staff",
      customer: "/customer",
      quotation: "/quotation",
      sales_order: "/sales-order",
      banner: "/banner",
      settings: "/settings",
    }),
    []
  );

  const menuItems = useMemo(
    () =>
      [
        {
          key: "dashboard",
          icon: <AiOutlineDashboard size={20} />,
          label: "Dashboard",
        },
        {
          key: "product",
          icon: <AiOutlineProduct size={20} />,
          label: "Product",
        },
        {
          key: "category",
          icon: <MdOutlineCategory size={20} />,
          label: "Category",
        },
        {
          key: "customer",
          icon: <TbUsersGroup size={20} />,
          label: "Customer",
        },
        {
          key: "staff",
          icon: <MdPeopleOutline size={20} />,
          label: "Staff",
        },
        {
          key: "quotation",
          icon: <RiBillLine size={20} />,
          label: "Quotation",
        },
        {
          key: "sales_order",
          icon: <BiPurchaseTag size={20} />,
          label: "Sales Order",
        },
        {
          key: "banner",
          icon: <PiFlagBannerFoldLight size={20} />,
          label: "Banner",
        },
        {
          key: "settings",
          icon: <AiOutlineSetting size={20} />,
          label: "Settings",
        },
      ].filter((item) => {
        if (item.key === "dashboard" || item.key === "settings") {
          return true;
        }
        if (user && user?.role === "Staff") {
          return userPermissions[item.key]?.view;
        }
        return true;
      }),
    [user, userPermissions]
  );

  // Memoized click handler
  const handleMenuClick = useCallback(
    ({ key }) => {
      navigate(routes[key]);
    },
    [navigate, routes]
  );
  const selectedKey = useMemo(() => {
    return Object.keys(routes).find(
      (key) =>
        routes[key] === location.pathname ||
        location.pathname.startsWith(routes[key])
    );
  }, [location.pathname, routes]);

  return (
    <StyledSider trigger={null} collapsible collapsed={collapsed} width="15vw">
      <div className="logo-div clickable" onClick={() => navigate("/")}>
        {collapsed ? (
          <img src={logoMini} className="logo" alt="Parts Pal Logo" />
        ) : (
          <img src={logo} className="logo" alt="Parts Pal Logo" />
        )}
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKey]}
        onClick={handleMenuClick}
        className="sider-menu"
        items={menuItems}
      />
    </StyledSider>
  );
};

const StyledSider = styled(Sider)`
  background: black !important;
  .sider-menu {
    background: black !important;
  }
  .ant-menu-item-selected {
    background-color: #ba5e3c;
  }
`;
